<template>
    <navigation />

    <promo-header>
        <h1>
          {{ $t("home.heading") }}
        </h1>
    </promo-header>

    <section class="section section-blue">

        <div class="container">

            <h2 class="mb-4">
                {{ $t("about.title") }}
            </h2>

            <h5 class="sub-heading mb-2">
                {{ $t("about.subtitle") }}
            </h5>

            <p>
                {{ $t("about.paragraph_1") }}
            </p>

            <p>
                {{ $t("about.paragraph_2") }}
                {{ $t("about.paragraph_3") }}
                {{ $t("about.paragraph_4") }}
            </p>

            <p>
                {{ $t("about.paragraph_5") }}

                {{ $t("about.attendTraining") }}: <a :href="`https://www.${$app.parentDomain}`" target="_blank" rel="noopener">{{ $app.parentDomain }}</a>
            </p>

            <p>
                {{ $t("about.paragraph_6") }}
            </p>

            <p>
                <a href="http://newsletter.tntministries.org.uk/" target="_blank" rel="noopener" title="Read newsletter">
                    {{ $t("about.readNewsletter") }}
                </a>.
            </p>

            <hr class="my-4" />

            <h5 class="sub-heading mb-2">
                {{ $t("statementOfFaith.title") }}
            </h5>

            <p>
                {{ $t("statementOfFaith.read") }}:
                <a
                    href="/statement-of-faith"
                    target="_blank"
                    :title="$t('statementOfFaith.read')"
                >
                    {{ $t("statementOfFaith.title") }}
                </a>.
            </p>

        </div>

    </section>

    <site-footer />
</template>

<script>
import PromoHeader from "../partials/PromoHeader.vue";
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import Products from "../partials/Products.vue";
import Pricing from "../partials/Pricing.vue";

export default {
    name: "About",

    components: {
        PromoHeader,
        Navigation,
        Products,
        Pricing,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("about.title")}`,
            meta: [
                {
                    name: 'description',
                    content: "We publish faithful, creative and effective Bible teaching material for children’s and youth ministries.",
                },
            ],
        };
    },
};
</script>
